import common from './common';

const usernameMinMaxLengthMessage = 'Must be 4-200 characters long';
export const validationRules = {
  email: {
    required: common.validationRules.required,
    validate: common.validationRules.email,
    minLength: {
      value: 2,
      message: usernameMinMaxLengthMessage,
    },
    maxLength: {
      value: 200,
      message: usernameMinMaxLengthMessage,
    },
  },
  password: {
    required: common.validationRules.required,
    minLength: {
      value: 8,
      message: 'Must be at least 8 characters long',
    },
  },
  currentPassword: {
    minLength: {
      value: 8,
      message: 'Must be at least 8 characters long',
    },
  },
  newPassword: {
    minLength: {
      value: 8,
      message: 'Must be at least 8 characters long',
    },
  },
  confirmPassword: {
    minLength: {
      value: 8,
      message: 'Must be at least 8 characters long',
    },
    validate: (value, formValues) => value === formValues.newPassword || 'Passwords do not match',
  },
  code: {
    minLength: {
      value: 6,
      message: 'Must be 6 characters long',
    },
    maxLength: {
      value: 6,
      message: 'Must be 6 characters long',
    },
  },
  status: {
    required: common.validationRules.required,
  },
  lastNameEng: {
    required: common.validationRules.required,
    maxLength: common.validationRules.maxLength255,
    validate: common.validationRules.englishOnly,
  },
  firstNameEng: {
    required: common.validationRules.required,
    maxLength: common.validationRules.maxLength255,
    validate: common.validationRules.englishOnly,
  },
  lastNameChi: {
    maxLength: common.validationRules.maxLength255,
    validate: common.validationRules.chineseOnly,
  },
  firstNameChi: {
    maxLength: common.validationRules.maxLength255,
    validate: common.validationRules.chineseOnly,
  },
  receiptName: {
    maxLength: common.validationRules.maxLength255,
  },
  phone: {
    required: common.validationRules.required,
    // minLength: {
    //   value: 8,
    //   message: 'Must be 8 characters long',
    // },
    maxLength: {
      value: 15,
      message: 'The phone number should not exceed 15 characters',
    },
    validate: (value) => /^[0-9]+$/.test(value) || 'Only numbers are allowed',
  },
  countryCode: {
    maxLength: common.validationRules.maxLength255,
  },
  address: {},
  city: {
    maxLength: common.validationRules.maxLength255,
  },
  country: {
    maxLength: common.validationRules.maxLength255,
  },
  serviceId: {},
  remarks: {},
};

export const fields = {
  status: common.fields.status,
  email: {
    name: 'email',
    label: 'Email',
    type: 'text',
    readOnly: true,
  },
  currentPassword: {
    name: 'currentPassword',
    label: 'Current Password',
    type: 'password',
  },
  newPassword: {
    name: 'newPassword',
    label: 'New Password',
    type: 'password',
  },
  confirmPassword: {
    name: 'confirmPassword',
    label: 'Confirm Password',
    type: 'password',
  },
  lastNameEng: {
    name: 'lastNameEng',
    label: 'Last Name (English) *',
    type: 'text',
  },
  firstNameEng: {
    name: 'firstNameEng',
    label: 'First Name (English) *',
    type: 'text',
  },
  lastNameChi: {
    name: 'lastNameChi',
    label: 'Last Name (Chinese)',
    type: 'text',
  },
  firstNameChi: {
    name: 'firstNameChi',
    label: 'First Name (Chinese)',
    type: 'text',
  },
  phone: {
    name: 'phone',
    label: 'Phone *',
    type: 'tel',
    maxLength: 15,
  },
  countryCode: {
    name: 'countryCode',
    label: 'Country Code',
    type: 'text',
  },
  address: {
    name: 'address',
    label: 'Address',
    type: 'textarea',
  },
  city: {
    name: 'city',
    label: 'City',
    type: 'text',
  },
  country: {
    name: 'country',
    label: 'Country',
    type: 'text',
  },
  enable2FA: {
    name: 'enable2FA',
    label: 'Enable 2FA',
    type: 'select',
    options: [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' },
    ],
  },
  remarks: common.fields.remarks,
};

const form = {
  edit: [
    ['email', 'receiptName'],
    ['newPassword', 'confirmPassword'],
    ['lastNameEng', 'firstNameEng'],
    ['lastNameChi', 'firstNameChi'],
    ['address'],
    ['city', 'country'],
    ['countryCode', 'phone'],
    ['enable2FA'],
  ],
};

export default {
  validationRules,
  fields,
  form,
};
